module.exports = __webpack_public_path__ + "static/2-cdadab3a6f089023595c636553007946.png";